import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import LoadingSpinner from "../../components/LoadingSpinner";
import { SubmitButton } from "../../components/Input";
import { showToast } from "../../components/toast";

const DevTicketForm = () => {
  const [ticket, setTicket] = useState(null);
  const [ticketStatus, setTicketStatus] = useState([]);
  const [replyList, setReplyList] = useState([]);
  const [nextId, setNextId] = useState("");
  const [previousId, setPreviousId] = useState("");
  const [formData, setFormData] = useState({
    subscriberName: "",
    ticketTitle: "",
    ticketDescription: "",
    ticketReply: "",
    ticketImage: "",
    attachments: "",
    ticketStatus: 1,
    createdOn: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  const fetchTicket = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}devTicket/add/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data;
      const ticketData = data.ticket;
      setTicket(data.ticket);

      setFormData({
        subscriberName: ticketData.subscribername,
        ticketTitle: ticketData.ticket_title,
        ticketDescription: ticketData.ticket_description,
        ticketReply: "",
        ticketStatus: parseInt(ticketData.ticket_status),
        createdOn: ticketData.created_on || "",
        attachments: ticketData.attachments || ""
      });
      setReplyList(data.replytolist);
      setPreviousId(data.previousid || "");
      setNextId(data.nextid || "");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchTicket(id);
    }

    setTicketStatus([
      { value: 0, label: "Requested" },
      { value: 1, label: "Open" },
      { value: 2, label: "Closed" },
    ]);
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const files = e.target.files[0];
    setFormData((prev) => ({ ...prev, ticketImage: files }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('ticket_title', formData.ticketTitle);
    formDataToSend.append('ticket_description', formData.ticketDescription);
    formDataToSend.append('ticket_status', parseInt(formData.ticketStatus));
    formDataToSend.append('ticket_reply', formData.ticketReply);
    formDataToSend.append('attachments', formData.ticketImage);

    const url = id
      ? `${API_URL}devTicket/save/${id}`
      : `${API_URL}devTicket/save/{id}`;

    try {
      setLoading(true);
      const response = await axios.post(url, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        },
      });
      console.log(response);

      if (response.status === 201) {
        showToast.success(response.data.message);
        navigate(`/DevTicket/Ticket`);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata", // or your timezone
      })
      .replace(/\//g, "-")
      .replace(",", "")
      .toUpperCase();
  };

  return (
    <div className="page-header-fixed page-sidebar-fixed fade in mt-5">
      <div id="content">{loading && <LoadingSpinner />}</div>
      <div className="panel  panel-default with-rounded-corner with-shadow">
        <div className="d-flex align-items-center justify-content-between pt-2">
          <div className="panel-heading border-0">
            <span className="panel-title">
              {id ? "Edit " : "Add "}Dev Ticket
            </span>
          </div>
          <div className="me-3">
            {previousId !== "" && previousId !== null && (
              <button
                type="button"
                className="btn btn-default btn-sm"
                title="Previous Order"
                onClick={() => navigate(`/DevTicket/Ticket/edit/${previousId}`)}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
            )}
            &nbsp;
            {nextId !== "" && nextId !== null && (
              <button
                type="button"
                className="btn btn-default btn-sm"
                title="Next Order"
                onClick={() => navigate(`/DevTicket/Ticket/edit/${nextId}`)}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            )}
          </div>
        </div>
        <div className="panel-body">
          <div className="row">
            {id && (
              <div className="col-md-4">
                <div className="form-group">
                  <label>User Name</label>
                  <input
                    type="text"
                    name="subscriberName"
                    className="form-control"
                    value={formData.subscriberName}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
              </div>
            )}

            <div className="col-md-4">
              <div className="form-group">
                <label>Status</label>
                <select
                  name="ticketStatus"
                  className="form-control"
                  value={formData.ticketStatus}
                  onChange={handleInputChange}
                >
                  {ticketStatus.map((status, index) => (
                    <option key={index} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group">
                <label>Upload Image</label>
                <input
                  type="file"
                  name="ticketImage"
                  className="form-control"
                  onChange={handleFileChange}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label>Query Title</label>
                <input
                  type="text"
                  name="ticketTitle"
                  className="form-control"
                  placeholder="Enter Query Title"
                  value={formData.ticketTitle}
                  onChange={handleInputChange}
                  disabled={id}
                />
              </div>
            </div>

            <div className="col-md-12">
              <fieldset className="form-group">
                <label>Query Explanation</label>
                <textarea
                  name="ticketDescription"
                  className="form-control"
                  placeholder="Enter Query Explanation"
                  value={formData.ticketDescription}
                  onChange={handleInputChange}
                  disabled={id}
                />
              </fieldset>
            </div>

            {id && (
              <div className="col-md-12">
                <fieldset className="form-group">
                  <label>Reply to Ticket</label>
                  <textarea
                    name="ticketReply"
                    className="form-control"
                    value={formData.ticketReply}
                    placeholder="Enter Ticket Reply"
                    onChange={handleInputChange}
                  />
                </fieldset>
              </div>
            )}

            {ticket && ticket.attachments && (
              <div className="d-flex col-md-12">
                <a href={ticket.attachments} className="html5lightbox">
                  <img
                    src={ticket.attachments}
                    alt="Attachment"
                    className="img-responsive"
                    style={{ width: "100px" }}
                  />
                </a>

              </div>
            )}

            <div className="col-12">
              <SubmitButton
                handleSubmit={handleSubmit}
                pageBack={`/DevTicket/Ticket`}
              />
            </div>
          </div>
        </div>
      </div>

      {replyList.map((reply, index) => (
        <div
          key={index}
          className="panel panel-default with-rounded-corner with-shadow"
        >
          <div className="post">
            <div className="post-header">
              <div className="post-header-img">
                <img src={reply.user_image} alt={reply.user_fullname} />
              </div>
              <div className="post-header-info">
                <h4>
                  <a href="#">{reply.user_fullname}</a>
                </h4>
                <span className="time">{formatDate(reply.created_on)}</span>
              </div>
            </div>
            <div className="post-content">
              <p className="post-desc">{reply.reply_description}</p>
            </div>
          </div>
        </div>
      ))}

      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default DevTicketForm;
